/* eslint-disable max-len */
import React from 'react';
import { Link } from '@thd-olt-component-react/router';
import { Helmet } from 'react-helmet-async';

export const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Home Page</title>
        <link
          href="https://www.homedepot.com/"
          rel="canonical"
        />
      </Helmet>
      <div style={{ padding: '3rem 10rem' }}>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>PIP</h2>
        <ul>
          <li>
            <Link
              to="/p/Novogratz-Magnolia-84-in-Rounded-Arm-1-Piece-Velvet-L-Shaped-Reversible-Sectional-Sofa-in-Blue-w-Pocket-Coils-and-Pillows-DA2006579N/321238574"
            >
              Sofa (in-stock)
            </Link>
          </li>
          <li>
            <Link
              to="/p/304217938"
            >
              Sofa (discontinued)
            </Link>
          </li>
        </ul>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>Browse</h2>
        <ul>
          <li>
            <Link
              to="/b/Furniture/N-5yc1vZc7pc"
            >
              Browse Furniture Category
            </Link>
          </li>
          <li>
            <Link
              to="/b/Furniture-Kitchen-Dining-Room-Furniture-Dining-Chairs/N-5yc1vZc7p6/Ntk-elasticplus/Ntt-dining%2Broom%2Btable?NCNI-5&sortby=bestmatch&sortorder=none"
            >
              Browse Furniture
            </Link>
          </li>
          <li>
            <Link
              to="/b/Kitchen-Tableware-Bar-Bar-Accessories/N-5yc1vZcexg"
            >
              Hybrid PLP
            </Link>
          </li>
        </ul>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>Search</h2>
        <ul>
          <li>
            <Link
              to="/s/dining%20room%20table?NCNI-5"
            >
              Search Furniture
            </Link>
          </li>
        </ul>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>PEP</h2>
        <ul>
          <li>
            <Link
              to="/pep/Novogratz-Magnolia-84-in-Rounded-Arm-1-Piece-Velvet-L-Shaped-Reversible-Sectional-Sofa-in-Blue-w-Pocket-Coils-and-Pillows-DA2006579N/321238574"
            >
              PEP (in-stock)
            </Link>
          </li>
          <li>
            <Link
              to="/pep/Baxton-Studio-Amaris-5-Piece-Black-Leather-Reclining-Sectional-28862-7896-HD/304217938"
            >
              PEP (discontinued)
            </Link>
          </li>
        </ul>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>Collections</h2>
        <ul>
          <li>
            <Link
              to="/collection/Home-Decor/Legends-800-Thread-Count-Egyptian-Cotton-Sateen-Collection/Family-306051327"
            >
              List View Collection
            </Link>
          </li>
          <li>
            <Link
              to="/collection/Kitchen/Cooling-Ceramic-Collection/Family-303616654"
            >
              Integrated Brand Collection
            </Link>
          </li>
          <li>
            <Link
              to="/collection/Outdoors/Ridge-Falls-Collection/Family-311423205"
            >
              Grouped View Collection
            </Link>
          </li>
          <li>
            <Link
              to="/collection/living-room/bold-bungalow-living-room/id-38127"
            >
              Space Collection
            </Link>
          </li>
          <li>
            <Link
              to="/collection/kitchen-cabinets/avondale-shaker-quick-assemble-plywood-base-cabinets-in-alpine-white"
            >
              Kitchen Cabinets Collection
            </Link>
          </li>
        </ul>
        <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>Miscellaneous</h2>
        <ul>
          <li>
            <Link
              to="/room"
            >
              Room
            </Link>
          </li>
          <li>
            <Link to="/stylequiz">
              Style Quiz
            </Link>
          </li>
          <li>
            <Link to="/bath-renovation">
              Bath Renovation Landing Page
            </Link>
          </li>
          <li>
            <Link to="/orange-lens">
              Orange Lens
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

Home.propTypes = {};

Home.defaultProps = {};
